import React from 'react';
import EmailConfirmationBanner from '../common/EmailConfirmationBanner.jsx';
import NavBar from './Navigation/NavBar.jsx';
import MobileMenu from './Navigation/MobileMenu.jsx';
import ContentRouter from './ContentRouter.jsx';
import MainLayout from './layouts/MainLayout.jsx';
import AuthenticatedLayout from './layouts/AuthenticatedLayout.jsx';
import Footer from '../common/Footer.jsx';
import { log } from '../../utils/logger';

// Utility imports are now handled by ContentRouter context

const Dashboard = ({
  currentUser,
  reservations,
  venues,
  mobileMenuOpen,
  setMobileMenuOpen,
  isDesktop,
  _setIsDesktop,
  showHotelSearch,
  hotelSearchData,
  preservedReservationState,
  setPreservedReservationState,
  handleHotelSearch,
  setShowHotelSearch,
  setHotelSearchData,
  activeTab,
  setActiveTab,
  reservationSuccess,
  setReservationSuccess,
  handleAccountUpdateSuccess,
  actions,
  dashboardData
}) => {

  return (
    <MainLayout>
      <NavBar
        currentUser={currentUser}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        preservedReservationState={preservedReservationState}
        setPreservedReservationState={setPreservedReservationState}
        reservationSuccess={reservationSuccess}
        setReservationSuccess={setReservationSuccess}
        isDesktop={isDesktop}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        handleLogout={async () => {
          try {
            const { supabase } = await import('../../lib/supabase');
            await supabase.auth.signOut();
          } catch (err) {
      // Error caught and ignored
            log.error('Error signing out:', err);
          }
        }}
      />

      <MobileMenu
        currentUser={currentUser}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        handleLogout={async () => {
          try {
            const { supabase } = await import('../../lib/supabase');
            await supabase.auth.signOut();
          } catch (err) {
      // Error caught and ignored
            log.error('Error signing out:', err);
          }
        }}
      />

      <div className="theme-background flex flex-col min-h-screen">
        <AuthenticatedLayout>
          <div className="px-4 sm:px-6 pt-4 sm:pt-6">
            <EmailConfirmationBanner user={currentUser} />
          </div>

          <ContentRouter
            currentUser={currentUser}
            reservations={reservations}
            venues={venues}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            showHotelSearch={showHotelSearch}
            hotelSearchData={hotelSearchData}
            setShowHotelSearch={setShowHotelSearch}
            setHotelSearchData={setHotelSearchData}
            preservedReservationState={preservedReservationState}
            setPreservedReservationState={setPreservedReservationState}
            reservationSuccess={reservationSuccess}
            setReservationSuccess={setReservationSuccess}
            handleAccountUpdateSuccess={handleAccountUpdateSuccess}
            handleHotelSearch={handleHotelSearch}
            actions={actions}
            dashboardData={dashboardData}
          />

          <Footer />
        </AuthenticatedLayout>
      </div>
    </MainLayout>
  );
};

export default Dashboard;
